import { compose, curry, prop } from 'ramda';

import { DocumentType } from '../types/document';
import { getLocale } from './i18n';

export const getEntities = prop('entities');

const getLocalizedEntities = (state) =>
  compose(prop(getLocale(state)), getEntities)(state);

export const getEntitiesOfType = curry((type, state) =>
  compose(prop(type), getLocalizedEntities)(state)
);

export const getDocById = curry((type, id, state) => {
  const doc = getEntitiesOfType(type, state)?.[id];
  // TODO: Remove this when migration was done
  if (!doc && type === DocumentType.MEDIA_PRESS) {
    return getEntitiesOfType(DocumentType.PRESS_RELEASE, state)?.[id];
  }
  return doc;
});

export const getSingleTypeDoc = curry((type, state) =>
  getDocByUid(type, type, state)
);

export const getDocByUid = curry((type, uid, state) =>
  compose(
    (id) => (id ? getDocById(type, id, state) : null),
    prop(uid),
    prop(type),
    prop('uids'),
    getLocalizedEntities
  )(state)
);

export const getDocsByIds = curry((state, docs) =>
  (docs || [])
    .map(({ id, type }) => id && type && getDocById(type, id, state))
    .filter(Boolean)
);

export const getDocsByUids = curry((state, docs) =>
  (docs || [])
    .map(({ uid, type }) => uid && type && getDocByUid(type, uid, state))
    .filter(Boolean)
);
